// Lib
import { FC } from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
// Types
import { ProductMedia } from "types/media";
// Theme
import { theme } from "theme";
// Icons
import { DragIndicatorIcon, TrashIcon } from "icons";
// Styled
import { Button } from "styled/Buttons";
import { StyledImage, Wrapper } from "./styled";

type MediaItem = ProductMedia & {
  id: string;
};

interface MediaContentCardProps {
  media: MediaItem;
  onDelete: () => void;
}

export const MediaContentCard: FC<MediaContentCardProps> = ({
  media,
  onDelete,
}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: media.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    display: "flex",
    zIndex: isDragging ? "100" : "auto",
    boxShadow: isDragging ? theme.shadow.light : "none",
  };

  if (!media?.imageURL && !media?.posterURL) {
    return null;
  }

  return (
    <div ref={setNodeRef} style={style}>
      <Wrapper>
        <Button.SquaredIcon
          icon={<TrashIcon fill={theme.color.status.danger} />}
          style={{ position: "absolute", top: 10, right: 10, zIndex: 4 }}
          onClick={onDelete}
        />

        <Button.SquaredIcon
          icon={<DragIndicatorIcon />}
          {...listeners}
          {...attributes}
          style={{
            cursor: isDragging ? "grabbing" : "grab",
            position: "absolute",
            right: 10,
            bottom: 10,
            zIndex: 4,
          }}
        />

        <StyledImage src={media.imageURL || media.posterURL} preview={false} />
      </Wrapper>
    </div>
  );
};
